import { createContext, useContext } from 'react'

import type { Socket } from '@core/phoenix/core'

interface SocketContextValue {
  socket?: Socket
  recreateSocket?: (newParams?: Record<string, string>) => void
  urlParams?: Record<string, string>
}

export const SocketContext = createContext<SocketContextValue>({
  socket: undefined,
  recreateSocket: undefined,
  urlParams: undefined,
})

/** @returns The socket in the context. */
export function useSocketContext(): SocketContextValue {
  return useContext(SocketContext)
}
